module.exports = {
	"shared.crew.original-music-composer": "Komponist",
	"social-button.twitter": "Twitter",
	"shared.crew.publicist": "Publizist",
	"share-overlay.share": "Dieses Video teilen",
	"shared.crew.associate-producer": "Produktionsassistenz",
	"shared.crew.assistant-editor": "Schnittassistenz",
	"overlay.buy-from": "Von {price} kaufen",
	"shared.crew.agent": "Agent",
	"shared.crew.additional-photography": "Zusätzliche Kamera",
	"shared.crew.sound-editor": "Tonmeister",
	"shared.crew.print-shipper": "Print Shipper",
	"shared.crew.hairstylist": "Friseur",
	"shared.crew.makeup-effects": "Maskenbildner für Spezialeffekte",
	"social-button.pinterest": "Pinterest",
	"shared.crew.production-assistant": "Produktionsassistenz",
	"shared.crew.executive-producer": "Filmproduzent",
	"shared.crew.costumer": "Kostümbildner",
	"info-overlay.cast": "Besetzung",
	"shared.crew.stunt-coordinator": "Stunt-Koordinator",
	"shared.crew.academic-advisor": "Akademischer Berater",
	"shared.crew.swing-gang": "Set-Dekoration",
	"shared.crew.best-boy": "Erster Lichttechniker",
	"actions.purchased": "Dieses Video gehört Ihnen",
	"social-button.tumblr": "Tumblr",
	"quality.format": "{qualityValue}p",
	"shared.crew.set-decorator": "Set-Dekorateur",
	"shared.crew.adaptation": "Neuverfilmung",
	"shared.crew.school-administrator": "School Administrator",
	"shared.crew.cable-person": "Kabeltechniker",
	"shared.crew.digital-effects": "Digitaleffekte",
	"actions.rent": "Leihen {price}",
	"info-overlay.created-by": "Von {author}",
	"social-share.twitter": "\"{title}\" auf {siteUrl} anschauen",
	"shared.crew.production-designer": "Produktionsdesigner",
	"info-overlay.crew": "Filmstab",
	"shared.crew.producer": "Produzent",
	"shared.crew.2nd-unit-dir-of-photography": "Kameramann des zweiten Stabes",
	"shared.crew.special-effects": "Spezialeffekte",
	"actions.rented": "Ausgeliehen bis zum {date}",
	"shared.crew.boom-operator": "Tonassistenz",
	"shared.crew.story": "Geschichte",
	"shared.crew.script-supervisor": "Skript-Leitung",
	"shared.crew.director": "Regie",
	"shared.crew.choreographer": "Choreograf",
	"shared.crew.production-manager": "Produktionsmanager",
	"quality.auto": "Auto",
	"shared.crew.lead-person": "Kulissenbauleitung",
	"shared.crew.location-manager": "Standort Manager",
	"shared.crew.costume-designer": "Kostümbildner",
	"fullscreen.exit": "Vollbild",
	"shared.crew.technical-advisor": "Technischer Berater",
	"shared.crew.editor": "Editor",
	"shared.crew.additional-grip": "Zusätzliche Kamerabühne",
	"actions.buy": "Kaufen {price}",
	"shared.crew.assistant-camera": " Kameraassistenz",
	"shared.crew.writer": "Autor",
	"social-share.pinterest": "{title} - {description}",
	"shared.crew.collaborating-director": "Collaborating Director",
	"fullscreen.enter": "Vollbild",
	"shared.crew.animal-trainer": "Tiertrainer",
	"shared.crew.assistant-art-director": "Szenenbildassistenz",
	"shared.crew.key-grip": "Kamerabühne",
	"social-button.copy": "Kopieren",
	"shared.crew.makeup-artist": "Maskenbildner",
	"overlay.source-error": "Dieses Video kann nicht abgespielt werden",
	"social-button.link": "Link",
	"actions.buy-from": "Kaufen von {price}",
	"shared.crew.art-director": "Szenenbildner",
	"shared.crew.production-coordinator": "Poduktionskoordinator",
	"shared.crew.co-director": "Co-Regie",
	"shared.crew.co-producer": "Co-Produzent",
	"shared.crew.video-operator": "Videooperator",
	"shared.crew.camera-operator": "Kameraoperateur",
	"shared.crew.co-writer": "Co-Autor",
	"shared.crew.set-designer": "Set-Designer",
	"shared.crew.preview-return": "Preview Return",
	"shared.crew.property-master": "Requisiteur",
	"shared.crew.cinematographer-dp": "Kamera",
	"shared.crew.grip": "Kamerabühnenassistenz",
	"social-share.tumblr": "{title} - {siteUrl}",
	"shared.crew.sound-mixer": "Tonmischer",
	"quality.label": "Qualität",
	"social-button.facebook": "Facebook",
	"shared.crew.gaffer": "Oberbeleuchter",
	"shared.crew.assistant-director": "Regieassistenz",
	"actions.subscribe": "Abonnieren {price}/Monat",
	"shared.crew.print-return": "Print Return",
	"shared.crew.animator": "Animator",
	"shared.crew.dolly-grip": "Kamerabühne",
	"shared.crew.manager": "Manager",
	"shared.crew.2nd-assistant-director": "Zweiter Assistenzdirektor",
	"shared.crew.author-of-adapted-material": "Drehbuchautor für adaptiertes Material"
};


//////////////////
// WEBPACK FOOTER
// ./src/widget/player-widget/translations/widget-texts_de.json
// module id = 2784
// module chunks = 66